<!-- <div style="display: flex;
justify-content: center;
align-items: center;
text-align: center;
left:50%;
top:50%;

min-height: 10vh;z-index: 2147483647!important;position: fixed;" class="progress-loader" [hidden]="!loadingprogress">
    <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50" style="color: chocolate !important;">
    </mat-progress-spinner>
</div> -->


<!-- <div style="  z-index: 99999999999;
position: fixed;
left: 0;
right: 0;
top:  -10px;
height: 6px;

padding: 0;" [hidden]="!loadingprogress">
    <img style="
       width: 100%; 
       max-height: 6px;" src="../../../assets/images/line.gif">
</div> -->

<div  [hidden]="!loadingprogress" class="w3-modal">
    <div class="w3-modal-content">
    <img style="
       width: 100%; 
       height: 100%;" src="../../../assets/images/giphy2.gif">
    </div>
</div>